import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class EmailRoute extends Route {
  @service availableServices;

  beforeModel() {
    this.availableServices.requireAccessTo(this, "domains");
  }
}
